(function () {
  if (window.__TTETA_INIT__) return; // guard if loaded twice
  window.__TTETA_INIT__ = true;

  const CACHE = {}; // url -> parsed JSON

  function parseHolidays(s) {
    return (s || "")
      .split(",")
      .map((x) => x.trim())
      .filter(Boolean);
  }

  function addDaysBusiness(start, days, holidays, businessDays) {
    let d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (businessDays) {
        const isSunday = d.getDay() === 0;
        const ymd = d.toISOString().slice(0, 10);
        const isHoliday = holidays.includes(ymd);
        if (isSunday || isHoliday) continue;
      }
      added++;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
  }

  async function getMap(url) {
    if (CACHE[url]) return CACHE[url];
    const res = await fetch(url, { cache: "force-cache" });
    if (!res.ok) throw new Error("ETA JSON fetch failed");
    const data = await res.json();
    CACHE[url] = data;
    return data;
  }

function fitOneLine(el, minPx = 11, maxPx = 16) {
  if (!el) return;
  // reset to max, then shrink until it fits or hits min
  el.style.fontSize = maxPx + "px";
  let size = maxPx, guard = 0;
  while (el.scrollWidth > el.clientWidth && size > minPx && guard < 20) {
    size -= 1;
    el.style.fontSize = size + "px";
    guard++;
  }
}


  function initOne(root) {
    if (!root || root.dataset.ttetaBound === "1") return;
    root.dataset.ttetaBound = "1";

    const input = root.querySelector(".tt-eta__input");
    const btn   = root.querySelector(".tt-eta__btn");
    const msg   = root.querySelector(".tt-eta__msg");

    const jsonUrl = root.dataset.json;
    const holidays = parseHolidays(root.dataset.holidays);
    const businessDays = root.dataset.business === "true";

    if (!jsonUrl || !input || !btn || !msg) return;

    function setMsg(t) {
  msg.textContent = t;
  fitOneLine(msg);
}


    function validPin(pin) { return /^\d{6}$/.test(pin); }

    async function onCheck() {
      const pin = (input.value || "").replace(/\D+/g, "").slice(0, 6);
      if (!validPin(pin)) { setMsg("Please enter a valid 6-digit pincode."); return; }
      setMsg("Checking…");
      try {
        const map = await getMap(jsonUrl);
        const rec = map[pin];
        if (!rec) { setMsg("Delivery estimate not available for this pincode."); return; }
        const today = new Date();
        const d1 = addDaysBusiness(today, parseInt(rec.min, 10), holidays, businessDays);
        const d2 = addDaysBusiness(today, parseInt(rec.max, 10), holidays, businessDays);
        const range = (d1.getTime() === d2.getTime()) ? fmt(d1) : `${fmt(d1)} – ${fmt(d2)}`;
       msg.innerHTML = `<span class="tt-eta__icon" aria-hidden="true">🚚</span><span class="tt-eta__msg-label">Expected delivery date</span> <strong class="tt-eta__date">${range}</strong>`;
fitOneLine(msg);

        try { localStorage.setItem("tt_last_pin", pin); } catch(_) {}
      } catch (e) {
        setMsg("Couldn’t fetch delivery estimate. Please try again.");
      }
    }

    // events
    root.addEventListener("click", function (e) {
      if (e.target && e.target.classList.contains("tt-eta__btn")) onCheck();
    });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") onCheck(); });

    // enable/disable UX
    function updateBtn() {
      const pin = (input.value || "").replace(/\D+/g, "");
      btn.disabled = pin.length !== 6;
    }
    input.addEventListener("input", updateBtn);
    updateBtn();

    // prefill last pin
    try {
      const last = localStorage.getItem("tt_last_pin");
      if (last && /^\d{6}$/.test(last)) { input.value = last; updateBtn(); }
    } catch(_) {}
  }

  function scan() {
    document.querySelectorAll(".tt-eta").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:select", scan);
  document.addEventListener("shopify:block:select", scan);
})();
